import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/images/logo.png";
import coloredLogo from "../../assets/images/coloredLogo.png";
import DropDownListItem from "./DropDownListItem";
import { MenuIcon, XIcon } from "@heroicons/react/outline";

const Header = ({ home }) => {
  const [nav, setNav] = useState(false);
  const handleClick = () => setNav(!nav);

  const handleClose = () => setNav(!nav);
  const logoImg = home ? coloredLogo : logo;
  const data = [
    { title: "IT services", path: "/it-services" },
    { title: "software solutions", path: "/software" },
    { title: "cyber security", path: "/cyber-security" },
    { title: "cloud & servers", path: "/cloud-servers" },
    { title: "data backup & protection", path: "/data-backup" },
    { title: "network & switching", path: "/network-switching" },
    { title: "smart home", path: "/smart-home" },
    { title: "audio-video", path: "/audio-video" },
    { title: "smart home", path: "/smart-home" },
  ];
  return (
    <nav
      className={`nav-area w-screen z-10 flex justify-between items-center font-medium md:px-24 px-5 md:pt-0 pt-5 absolute ${
        home ? "bg-white text-black" : "text-white"
      }`}
    >
      <div className="logo_container">
        <Link to={"/"}>
          <img src={logoImg} alt="" className="md:h-[40px] h-[25px]" />
        </Link>
      </div>
      <ul className="hidden md:flex">
        <li
          style={{ cursor: "pointer" }}
          className={`flex font-medium hover:text-pink-600`}
        >
          <Link to={"/about"}>About</Link>
        </li>
        <li
          style={{ cursor: "pointer" }}
          className={`flex font-medium hover:text-pink-600`}
        >
          <Link to={"/products"}>Products</Link>
        </li>
        <li
          style={{ cursor: "pointer" }}
          className={`flex font-medium hover:text-pink-600`}
        >
          {/* <a href="#">Services</a> */}
          <a href="#">Services</a>
          {/* <AiFillCaretDown className="text-indigo-600" size={24} /> */}
          <div className="bg-white z-10 services">
            <ul className="bg-white drop_container">
              {data.map((item, index) => (
                <DropDownListItem
                  key={index}
                  item={item}
                  index={index}
                  length={data.length}
                />
              ))}
            </ul>
          </div>
        </li>
        {/* <li
          style={{ cursor: "pointer" }}
          className={`flex font-medium hover:text-pink-600`}
        >
          <Link to={"/patners"}>Patners</Link>
        </li> */}
        <li
          style={{ cursor: "pointer" }}
          className={`flex font-medium hover:text-pink-600`}
        >
          <Link to="/contact">Contact</Link>
        </li>
      </ul>
      <div className="md:hidden" onClick={handleClick}>
        {!nav ? <MenuIcon className="w-5" /> : <XIcon className="w-5" />}
      </div>

      <ul
        className={
          !nav ? "hidden" : "absolute top-20 left-0 bg-zinc-200 w-full"
        }
      >
        <li className="border-b-2 border-zinc-300 w-full text-black">
          <Link onClick={handleClose} to="/about" smooth={true} duration={500}>
            About Us
          </Link>
        </li>
        <li className="border-b-2 border-zinc-300 w-full text-black">
          <Link
            onClick={handleClose}
            to="/patners"
            smooth={true}
            offset={-200}
            duration={500}
          >
            Partners
          </Link>
        </li>
        <li className="border-b-2 border-zinc-300 w-full text-black">
          <Link
            onClick={handleClose}
            to="/products"
            smooth={true}
            offset={-50}
            duration={500}
          >
            Products
          </Link>
        </li>
        <li
          style={{ cursor: "pointer" }}
          className={`flex font-medium hover:text-pink-600 text-black`}
        >
          {/* <a href="#">Services</a> */}
          <a href="#">Services</a>
          {/* <AiFillCaretDown className="text-indigo-600" size={24} /> */}
          <div className="bg-white z-10 services">
            <ul className="bg-white drop_container">
              {data.map((item, index) => (
                <DropDownListItem
                  key={index}
                  item={item}
                  index={index}
                  length={data.length}
                />
              ))}
            </ul>
          </div>
        </li>
        {/* <li className="border-b-2 border-zinc-300 w-full">
          <Link
            onClick={handleClose}
            to="/products"
            smooth={true}
            offset={-100}
            duration={500}
          >
            Services
          </Link>
        </li> */}
        <li className="border-b-2 border-zinc-300 w-full text-black">
          <Link
            onClick={handleClose}
            to="/contact"
            smooth={true}
            offset={-50}
            duration={500}
          >
            Contact Us
          </Link>
        </li>
      </ul>
    </nav>
  );
};

export default Header;
